import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const GroupLabel = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  text-align: left;
  padding: 18px 12px 4px;
  font-weight: 500;
  color: #999999;
`;

const Option = styled.a`
  display: block;
  color: inherit;
  font-size: 14px;
  padding: 12px;
  text-align: left;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
`;

const AlbumDownloadTooltipBody = ({ options, onSelect, id }) => {
  return (
    <div>
      {options.map(({ label: groupLabel, options: groupOptions }, index) => (
        <React.Fragment key={`${id}-${groupLabel}`}>
          <GroupLabel>{groupLabel}</GroupLabel>
          {groupOptions.map(({ label, value, type }) => (
            <Option
              key={`${id}-${value}-${index}`}
              onClick={ev => {
                ev.stopPropagation();
                onSelect(type, value);
              }}
            >
              {label}
            </Option>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

AlbumDownloadTooltipBody.propTypes = {
  options: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default AlbumDownloadTooltipBody;
